<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="links" :title="company ? company.name : null" :logo="company ? company.logo : null" :to="{name: 'View'}">
      <user-menu></user-menu>
      <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" value="" class="form-control" placeholder="Search...">
        </div>
      </form>
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from '@/components/Dashboard/Layout/TopNavbar.vue'
  import ContentFooter from '@/components/Dashboard/Layout/ContentFooter.vue'
  import DashboardContent from '@/components/Dashboard/Layout/Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'

  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu
    },
    watch: {
      company (company) {
        this.fetchAllStores(company)
      }
    },
    mounted () {
      this.fetchAllStores(this.company)
    },
    computed: {
      ...mapGetters('profiles', {
        profile: 'mine'
      }),
      ...mapGetters('companies', {
        company: 'mine'
      }),
      ...mapGetters('stores', {
        stores: 'all'
      }),
      storeLinks () {
        if (this.stores) {
          if (this.stores.length > 1) {
            return {
              name: 'Boutiques',
              icon: 'ti-home',
              collapsed: true,
              children: [{
                name: 'Liste',
                to: { name: 'StoreList', params: { company: this.$route.params.company } }
              },
              {
                name: 'Statistiques',
                to: { name: 'StoreStats', params: { company: this.$route.params.company } }
              }
              ]
            }
          }
        }
      },
      links () {
        const dashboard = {
          name: 'Tableau de bord',
          icon: 'ti-panel',
          to: { name: 'Dashboard', params: { company: this.$route.params.company } }
        }
        return [
          dashboard,
          this.storeLinks,
          {
            name: 'Produits',
            icon: 'ti-view-list-alt',
            to: { name: 'ProductList', params: { company: this.$route.params.company } }
          },
          {
            name: 'Commandes',
            icon: 'ti-credit-card',
            to: { name: 'OrderList', params: { company: this.$route.params.company } }
          }
        ]
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      ...mapActions('stores', {
        fetchAllStores: 'bind'
      })
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/Company/Index.vue